import { useRouterState } from '@tanstack/react-router';

import { type Domain, DOMAINS } from './domains';

export function matchDomainFromPath(pathname: string): Domain {
  const firstSegment = pathname.split('/').find(Boolean) ?? '';
  const match = Object.values(DOMAINS).find((d) => d === firstSegment);

  return match ?? DOMAINS.EDUCATION;
}

export function useDomainName(): Domain {
  const { location } = useRouterState();

  return matchDomainFromPath(location.pathname);
}
